import React, { useState } from 'react';

import { ModalDefault } from '../../../../components/ModalDefault/ModalDefault';
import { pushNotify } from 'components/Notifications';
import { useOpenSupportDisputeMutation } from '../../../../redux/services/SupportApi';
import { type SupportOrder } from '../../../../redux/types/SupportTypes';
import { errorText, orderAmount } from '../helpers';
import styles from '../Support.module.css';

const MAX_FILES = 4;

type Props = { order: SupportOrder; onClose: () => void };

// Opens a dispute as the order's merchant: amount (defaults to the order amount), comment, up to 4 receipts (optional).
export const DisputeModal: React.FC<Props> = ({ order, onClose }) => {
  const [amount, setAmount] = useState(orderAmount(order));
  const [comment, setComment] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [openDispute, { isLoading }] = useOpenSupportDisputeMutation();

  const submit = async () => {
    const body = new FormData();
    if (amount.trim()) body.append('new_real_income', amount.trim().replace(',', '.'));
    if (comment.trim()) body.append('comment', comment.trim());
    files.slice(0, MAX_FILES).forEach((file) => body.append('files', file));
    try {
      await openDispute({ id: order.id, body }).unwrap();
      onClose();
    } catch (error) {
      pushNotify(errorText(error, 'Не удалось открыть спор'), 'Ошибка');
    }
  };

  return (
    <ModalDefault title={'Открыть спор от лица мерчанта'} active setActive={(value) => !value && onClose()}>
      <div className={styles.form}>
        <div className={styles.muted}>
          Заявка {order.id}
          <br />
          Мерчант {order.merchant} · трейдер {order.trader} · {order.currency_code_to}
        </div>
        <label>
          Сумма спора, {order.currency_code_to}
          <input value={amount} onChange={(event) => setAmount(event.target.value)} inputMode='decimal' />
        </label>
        <label>
          Комментарий
          <textarea value={comment} onChange={(event) => setComment(event.target.value)} placeholder='Что произошло' />
        </label>
        <label>
          Чеки (до {MAX_FILES}, необязательно)
          <input
            type='file'
            multiple
            accept='.pdf,.jpg,.jpeg,.png'
            onChange={(event) => setFiles(Array.from(event.target.files || []).slice(0, MAX_FILES))}
          />
        </label>
        <div className={styles.formButtons}>
          <button type='button' className={styles.actionButton} onClick={onClose} disabled={isLoading}>
            Отмена
          </button>
          <button type='button' className={styles.actionButton} onClick={submit} disabled={isLoading}>
            {isLoading ? 'Открываем…' : 'Открыть спор'}
          </button>
        </div>
      </div>
    </ModalDefault>
  );
};
